<mat-calendar
  [minDate]="minDate"
  [maxDate]="maxDate"
  [selected]="selected"
  [dateFilter]="dateFilter"
  (selectedChange)="onDateChange($event)"
  [headerComponent]="headerComponent"
  cdkTrapFocus
></mat-calendar>
